import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import {
  CorrespondenceRequestCategoryStoreActions,
  CorrespondenceRequestCategoryStoreSelectors,
  CorrespondenceRequestCategoryStoreReducer,
} from './index';
import { CorrespondenceRequestCategoryDto } from '@cradua/data';

@Injectable()
export class CorrespondenceRequestCategoryFacade {
  constructor(
    private store: Store<
      CorrespondenceRequestCategoryStoreReducer.CorrespondenceRequestCategoryPartialState
    >
  ) {}

  correspondenceRequestCategory$ = this.store.select(
    CorrespondenceRequestCategoryStoreSelectors.getSelected
  );
  correspondenceRequestCategoryError$ = this.store.select(
    CorrespondenceRequestCategoryStoreSelectors.getCorrespondenceRequestCategoryError
  );

  getselected() {
    return this.store.select(
      CorrespondenceRequestCategoryStoreSelectors.getSelected
    );
  }

  get isLoadingCorrespondenceRequestCategory() {
    this.store.dispatch(
      CorrespondenceRequestCategoryStoreActions.loadCorrespondenceRequestCategory()
    );
    return this.store.select(
      CorrespondenceRequestCategoryStoreSelectors.loadingCorrespondenceRequestCategory
    );
  }

  get loadCorrespondenceRequestCategory() {
    this.store.dispatch(
      CorrespondenceRequestCategoryStoreActions.loadCorrespondenceRequestCategory()
    );
    return this.store.select(
      CorrespondenceRequestCategoryStoreSelectors.getAllCorrespondenceRequestCategory
    );
  }

  addCorrespondenceRequestCategory(
    newCorrespondenceRequestCategory: CorrespondenceRequestCategoryDto[]
  ) {
    this.store.dispatch(
      CorrespondenceRequestCategoryStoreActions.addCorrespondenceRequestCategory(
        { newCorrespondenceRequestCategory }
      )
    );
  }

  updateCorrespondenceRequestCategory(
    updateCorrespondenceRequestCategory: CorrespondenceRequestCategoryDto[]
  ) {
    this.store.dispatch(
      CorrespondenceRequestCategoryStoreActions.updateCorrespondenceRequestCategory(
        { updateCorrespondenceRequestCategory }
      )
    );
  }

  removeCorrespondenceRequestCategory(ids: string[]) {
    this.store.dispatch(
      CorrespondenceRequestCategoryStoreActions.removeCorrespondenceRequestCategory(
        { ids }
      )
    );
  }
}
